import { useEffect } from "react";
import { SiteNav, SiteFooter } from "../components/SiteChrome";
import { trackPageView } from "../lib/analytics";
import "../styles/site.css";

export default function Support() {
  useEffect(() => {
    document.title = "C-STYL — Support";
    window.scrollTo(0, 0);
    trackPageView();
  }, []);

  return (
    <div className="site" data-testid="support-page">
      <SiteNav />

      <div className="doc">
        <h1 className="serif">Support</h1>
        <p className="muted" style={{ color: "#8b857c" }}>We’re here to help you get the most out of C-STYL.</p>

        <div className="grid-cards">
          <div className="card">
            <h3>Add your clothes</h3>
            <p>Photo, multi-upload, wardrobe scan, or receipt import — all auto-tagged.</p>
          </div>
          <div className="card">
            <h3>Daily outfits</h3>
            <p>Weather-aware looks from your own closet, with one tap for a fresh pick.</p>
          </div>
          <div className="card">
            <h3>See it on you</h3>
            <p>Add a full-body photo in Profile for realistic try-on previews.</p>
          </div>
          <div className="card">
            <h3>Delete your data</h3>
            <p>Profile → Delete account permanently removes everything.</p>
          </div>
        </div>

        <h2>Frequently asked</h2>
        <h3>How do I add my clothes?</h3>
        <p>Tap + Add, then take a photo, upload several photos, scan your wardrobe, or import from a receipt. C-STYL auto-tags each item.</p>
        <h3>Why aren’t my daily reminders arriving?</h3>
        <p>Reminders are scheduled on your device at the time set in Profile → Daily Reminder. Make sure notifications are allowed for C-STYL in your phone settings.</p>
        <h3>My try-on didn’t look right</h3>
        <p>Use a clear, well-lit, full-body photo facing the camera for the best results. You can regenerate the preview anytime.</p>

        <h2>Contact us</h2>
        <p>Email <a href="mailto:support@c-styl.com" style={{ color: "#C8A24C" }} data-testid="support-email">support@c-styl.com</a> and we’ll respond within 2 business days.</p>
      </div>

      <SiteFooter />
    </div>
  );
}
